import {create} from "@/api/rest";

const errorGenerator = {
  create: async (data) => await create('/error-generator', data),
};

export default errorGenerator;